import * as aesjs from 'aes-js';
import { DecryptParams, EncryptParams } from './aesCtrEncryption.types';

export class AesCtrEncryption {
  static encrypt({ counterValue, key, plaintext }: EncryptParams): string {
    const textBytes = aesjs.utils.utf8.toBytes(plaintext);

    const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(counterValue));

    const encryptedBytes = aesCtr.encrypt(textBytes);

    return aesjs.utils.hex.fromBytes(encryptedBytes);
  }

  static decrypt({ counterValue, encryptedHex, key }: DecryptParams): string {
    const encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);

    const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(counterValue));

    const decryptedBytes = aesCtr.decrypt(encryptedBytes);

    return aesjs.utils.utf8.fromBytes(decryptedBytes);
  }
}
